import axios from "@/libs/api.request.js";
import { getEnv } from "./heziShare";

// 会员等级接口
export const vipLevelApi = ({token, params}) => axios.request({ url: `${getEnv()}/wx-box-game/vip/rank?token=${token}`, data: params });

// VIP游戏列表接口
export const vipGameListApi = (params) => axios.request({ url: `${getEnv()}/wx-box-game/vip/game/list`,params,method: "get" });

// 会员权益
export const vipRightApi = () => axios.request({ url: `${getEnv()}/wx-box-game/vip/rights`, method: "get" });

// 礼包列表
export const vipGiftListApi = (params) => axios.request({ url: `${getEnv()}/wx-box-game/vip/gift/list`,params, method: "get"});

// 活动列表
export const vipActivityListApi = (params) => axios.request({ url: `${getEnv()}/wx-box-active/vip/activity/list`,params, method: "get"});

// 礼包领取
export const receiveGiftApi = ({token, params}) => axios.request({ url: `${getEnv()}/wx-box-game/vip/gift/receive?token=${token}`, data: params});

// 获取用户状态
export const getUserStatusApi = (data) => axios.request({ url: `${getEnv()}/wx-box-user/user/status`, data, requireToken: true});

// 绑定账号
export const bindUserApi = ({token, params}) => axios.request({ url: `${getEnv()}/wx-box-user/user/check?token=${token}`, data: params});



